import React, { useEffect, useCallback, useRef, useState, useMemo } from "react";

import axios from 'util/axios';

import Pagination, { SetPager } from "util/component/Pagination/v2";


const VIEW_PAGE = 15;
const VIEW_BLOCK = 5;

const SEARCHCONDITION = {
    userId: "",
    userNm: "",
};

const Users = (props) => {
    const TBL_DATA_REF = useRef([]);
    const TBL_DATA_ORIGIN = useRef([]);
    const [PAGER, SetPAGER] = useState(null);
    const [ SelectedUser, SetSelectedUser ] = useState(null);


    const [UserList, SetUserList] = useState([]);

    const [SearchCondition, SetSearchCondition] = useState(SEARCHCONDITION);

    const getUserList = async () => {
        const response = await axios
            .post(process.env.REACT_APP_API + "/user/retrieveUserList")
            .then((Response) => Response?.data?.data?.result);
        const dataMap = response.filter((d) => {
            let codes = [];
            try {
                codes = JSON.parse(d.codes);
            } catch (e) {}
            return codes.find((f) => f.code.toString() === "20");
        });

        TBL_DATA_ORIGIN.current = dataMap || [];
        TBL_DATA_REF.current = [...TBL_DATA_ORIGIN.current];

        const pager = new SetPager(TBL_DATA_REF.current.length, VIEW_PAGE, VIEW_BLOCK);
        SetPAGER({ data: pager });
        SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date().toString() }));
    };


    useEffect(() => {
        getUserList();
    }, []);

    useEffect(() => {
        if (!PAGER) return;
        const range = PAGER.data.getItemRange();
        let setData = [];
        for (let i = range.start; i < range.end; i++) {
            setData.push(TBL_DATA_REF.current[i]);
        }
        SetUserList(setData);
    }, [PAGER]);

    useEffect(() => {
        if(SelectedUser) {
            props?.SetSelectedUser(SelectedUser);
        }
    },[SelectedUser, props])

    const HandleSearchCondition = (element) => {
        const name = element.target.name;
        const value = element.target.value;
        SetSearchCondition((OLD) => ({ ...OLD, [name]: value }));
    };

    const inputDelayRef = useRef(null);

    useEffect(() => {
        clearTimeout(inputDelayRef.current);
        inputDelayRef.current = setTimeout(() => {
            const { userId, userNm } = SearchCondition;
            TBL_DATA_REF.current = TBL_DATA_ORIGIN.current;
            if (userId || userNm) {
                if (userId) {
                    if (userId.length >= 2) {
                        TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                            const regex = new RegExp(userId, "gi");
                            return f.userId.match(regex);
                        });
                    }
                }
                if (userNm) {
                    if (userNm.length >= 2) {
                        TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                            const regex = new RegExp(userNm, "gi");
                            return f.userNm.match(regex);
                        });
                    }
                }
            }
            if(SelectedUser) {
                if(!TBL_DATA_REF.current.find(f => f.code === SelectedUser.code)) {
                    TBL_DATA_REF.current = [SelectedUser, ...TBL_DATA_REF.current]
                }
                
            }
            const pager = new SetPager(TBL_DATA_REF.current.length, VIEW_PAGE, VIEW_BLOCK);
            SetPAGER({ data: pager });
        }, 500);
    }, [SearchCondition, SelectedUser]);

    return (
        <div className={"userAuthExternalTable"}>
            <table className={"bpl-table-default fixed has-pagination userAuthExternalTable-table"}>
                <colgroup>
                    <col width="150px" />
                    <col width="200px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>User ID</th>
                        <th>User Name</th>
                    </tr>
                    <tr>
                        <td>
                            <input
                                type="text"
                                className={"bpl-input-default"}
                                name={"userId"}
                                value={SearchCondition.userId}
                                placeholder={"ID"}
                                onChange={HandleSearchCondition}
                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                className={"bpl-input-default"}
                                name={"userNm"}
                                placeholder={"Name"}
                                value={SearchCondition.userNm}
                                onChange={HandleSearchCondition}
                            />
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {UserList?.map((rowData, index) => {
                        return (
                            <tr key={`UserAuthExternalList${index}`}
                            className={`${rowData.userId === SelectedUser?.userId ? "selected" : ""}`}
                            onClick={() => SetSelectedUser(rowData)}>
                                <td>{rowData.userId}</td>
                                <td>{rowData.userNm}</td>
                            </tr>
                        );
                    })}
                    {
                        UserList.length < 1 && (
                            <tr  className={"non-clickable"}>
                                <td colSpan={2}>
                                    No Users
                                </td>
                            </tr>
                        )
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="2">
                            <Pagination data={PAGER?.data} set={(data) => SetPAGER({ data: data, refresh: new Date() })} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default Users;